import { map, sumBy } from "lodash";
import { useTranslation } from "react-i18next";
import type { DailyReport } from "@/helpers/daily-report";
import { euros, Section, tableClassName } from "./layout";

const Vat = ({ report }: { report: DailyReport }) => {
	const { t } = useTranslation();

	return (
		<Section title={t("dailyReport.vat")}>
			<table className={tableClassName}>
				<thead>
					<tr>
						<th>{t("dailyReport.vatRate")}</th>
						<th className="text-right!">{t("dailyReport.taxFreeAmount")}</th>
						<th className="text-right!">{t("dailyReport.vatAmount")}</th>
						<th className="text-right!">{t("dailyReport.totalAmount")}</th>
					</tr>
				</thead>
				<tbody className="tabular-nums">
					{map(report.vatRates, (row) => (
						<tr key={row.ratePercentCents}>
							<td>{row.ratePercentCents / 100}%</td>
							<td className="text-right">{euros(row.taxFreeAmountCents)}</td>
							<td className="text-right">{euros(row.vatAmountCents)}</td>
							<td className="text-right">{euros(row.totalAmountCents)}</td>
						</tr>
					))}
					<tr className="font-semibold">
						<td>{t("dailyReport.total")}</td>
						<td className="text-right">
							{euros(sumBy(report.vatRates, "taxFreeAmountCents"))}
						</td>
						<td className="text-right">
							{euros(sumBy(report.vatRates, "vatAmountCents"))}
						</td>
						<td className="text-right">{euros(report.totalAmountCents)}</td>
					</tr>
				</tbody>
			</table>
		</Section>
	);
};

export default Vat;
